import { createFileRoute } from "@tanstack/react-router";
import { ThemeSlot } from "../../themes/slots";

export const Route = createFileRoute("/c/product/$itemId")({
  component: RouteComponent,
});

function RouteComponent() {
  const { itemId } = Route.useParams();
  return <ThemeSlot slot="productDetails" itemId={itemId} />;
}
